import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, OutlinedInput, InputLabel, Stack, FormHelperText, Box, Button } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DeleteIcon } from 'assets/svgs/index';
import { useFieldArray } from 'react-hook-form';

const Playbook = ({ control, errors, isShowDemoCompany = false }) => {
  const theme = useTheme();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tenant_playbook_values'
  });

  return (
    <Box>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <Stack spacing={1}>
            <InputLabel htmlFor="mission">Mission</InputLabel>
            <Controller
              name="tenant_mission"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <OutlinedInput
                  multiline
                  rows={3}
                  type="text"
                  placeholder="Mission"
                  id="mission"
                  value={field.value}
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  fullWidth
                  autoComplete={'on'}
                  error={Boolean(errors.tenant_mission)}
                  disabled={isShowDemoCompany}
                />
              )}
            />
            {errors.tenant_mission?.message && (
              <FormHelperText
                error
                id="standard-weight-helper-text-tenant_mission"
              >
                {errors.tenant_mission?.message}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Stack spacing={1}>
            <InputLabel htmlFor="tenant_vision">Vision</InputLabel>
            <Controller
              name="tenant_vision"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <OutlinedInput
                  multiline
                  rows={3}
                  type="text"
                  placeholder="Vision"
                  id="tenant_vision"
                  autoComplete={'on'}
                  value={field.value}
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  fullWidth
                  error={Boolean(errors.tenant_vision)}
                  disabled={isShowDemoCompany}
                />
              )}
            />
            {errors.tenant_vision?.message && (
              <FormHelperText
                error
                id="standard-weight-helper-text-tenant_vision"
              >
                {errors.tenant_vision?.message}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Stack spacing={1}>
            <InputLabel htmlFor="tenant_values">Values</InputLabel>
            {/* <Controller
              name="tenant_values"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <OutlinedInput
                  multiline
                  rows={3}
                  type="text"
                  placeholder="Values"
                  autoComplete={'on'}
                  id="tenant_values"
                  value={field.value}
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  fullWidth
                  error={Boolean(errors.tenant_values)}
                />
              )}
            />
            {errors.tenant_values?.message && (
              <FormHelperText
                error
                id="standard-weight-helper-text-tenant_values"
              >
                {errors.tenant_values?.message}
              </FormHelperText>
            )} */}
            {fields?.map((item, index) => (
              <Stack
                spacing={1}
                sx={{ mb: 2 }}
                key={item?.id + 'tenant_playbook_values'}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Controller
                    name={`tenant_playbook_values[${index}].tenant_values`}
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <OutlinedInput
                        id={`tenant_playbook_values-${index}`}
                        type="text"
                        value={field.value}
                        name={field.name}
                        onBlur={field.onBlur}
                        autoComplete={'on'}
                        onChange={field.onChange}
                        placeholder="Values"
                        fullWidth
                        error={Boolean(errors.tenant_playbook_values && errors.tenant_playbook_values[index]?.tenant_values)}
                        disabled={isShowDemoCompany}
                      />
                    )}
                  />
                  {index > 0 && !isShowDemoCompany && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      sx={{ minHeight: '36px', minWidth: '36px' }}
                      onClick={() => remove(index)}
                    >
                      <DeleteIcon stroke={theme.palette.secondary.main} />
                    </Button>
                  )}
                </Box>
                {errors.tenant_playbook_values && errors.tenant_playbook_values[index]?.tenant_values?.message && (
                  <FormHelperText
                    error
                    id="standard-weight-helper-text-tenant_playbook_values"
                  >
                    {errors.tenant_playbook_values[index]?.tenant_values?.message}
                  </FormHelperText>
                )}
              </Stack>
            ))}
          </Stack>
        </Grid>
        {!isShowDemoCompany && (
          <Grid xs={12}>
            <Stack
              direction="row"
              justifyContent="flex-end"
              sx={{ my: 2 }}
            >
              <Box></Box>
              <Button
                variant="outlined"
                color="secondary"
                type="button" // Use type="button" for adding
                onClick={() =>
                  append({
                    tenant_values: ''
                  })
                }
              >
                Add Values
              </Button>
            </Stack>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Playbook;
